import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import TitleIcon from '@mui/icons-material/Title';
import { styled } from '@mui/material/styles';
import { ReactComponent as PilotIcon } from 'images/pilotFilled.svg';

export const ActiveIconStyled = styled(CheckIcon)(({ theme }) => ({
  color: theme.palette.success.light,
}));

export const DisabledIconStyled = styled(DoNotDisturbAltIcon)(({ theme }) => ({
  color: theme.palette.error.light,
}));

export const TestIconStyled = styled(TitleIcon)(({ theme }) => ({
  color: theme.palette.warning.light,
}));

export const PilotIconStyled = styled(PilotIcon)(({ theme }) => ({
  color: theme.palette.warning.light,
  marginRight: 8,
}));
